import { render, staticRenderFns } from "./weixinbandView.vue?vue&type=template&id=7aa3c5a0&scoped=true"
import script from "./weixinbandView.vue?vue&type=script&lang=js"
export * from "./weixinbandView.vue?vue&type=script&lang=js"
import style0 from "./weixinbandView.vue?vue&type=style&index=0&id=7aa3c5a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa3c5a0",
  null
  
)

export default component.exports